import { render, staticRenderFns } from "./edit-domesticsalesprofit.vue?vue&type=template&id=2084d9eb"
import script from "./edit-domesticsalesprofit.vue?vue&type=script&lang=ts"
export * from "./edit-domesticsalesprofit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports